module.exports = __webpack_public_path__ + "img/draw-bottombox.c3ca9637.png";